//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex'

export default {
  name: 'FormVCode',
  props: {
    value: {
      type: [ String, Number, Boolean ],
      default: ''
    },
    mobile: String,
    appCode: String,
    required: Boolean
  },
  created () {
    this.val = this.value
  },
  mounted () {},
  data () {
    return {
      canGetVCodeFlag: true,
      timerInstance: null,
      seconds: 0,
      showErrorFlag: false,
      errorInfo: '',
      val: '',
      regexp: /^\d{4}$/
    }
  },
  computed: {},
  watch: {
    value (v) {
      this.val = v
    },
    val (v) {
      this.validate()
      this.$emit('input', v)
    }
  },
  filters: {},
  methods: {
    ...mapActions('sms', ['smsSendMobileCode']),

    async getVCode () {
      if (!/^(\+?0?86-?)?1[3456789]\d{9}$/.test(this.mobile)) {
        this.$wisToast('联系电话格式错误', 'error')
        return
      }
      this.$wisLoading(true)
      await this.smsSendMobileCode({
        appCode: this.appCode,
        tplCode: 'sms_common_code_msgtpl',
        mobile: this.mobile
      })
      this.$wisLoading(false)
      this.canGetVCodeFlag = false
      if (!this.timerInstance) {
        clearInterval(this.timerInstance)
      }
      this.seconds = 60
      this.timerInstance = setInterval(() => {
        if (this.seconds === 1) {
          clearInterval(this.timerInstance)
          this.timerInstance = null
          this.canGetVCodeFlag = true
        } else {
          this.seconds--
        }
      }, 1000)
    },
    validate () {
      this.showErrorFlag = false
      this.errorInfo = ''
      if (this.required && this.val === '') {
        this.showErrorFlag = true
        this.errorInfo = `验证码不能为空`
        return false
      }
      if (this.val && this.regexp && this.regexp instanceof RegExp && !this.regexp.test(this.val)) {
        this.showErrorFlag = true
        this.errorInfo = `格式错误`
        return false
      }
      return true
    },
    clear () {
      this.canGetVCodeFlag = true
      if (!this.timerInstance) {
        clearInterval(this.timerInstance)
      }
      this.seconds = 0
    }
  }
}
